/** CPF/CNPJ: reaproveita a mascara de fornecedores (nao duplicar). */
export { mascaraDocumento as mascaraCpfCnpj } from '@/components/fornecedores/documento';

/** CEP "00000-000". So digitos entram; corta em 8. */
export function mascaraCep(valor: string): string {
  const d = valor.replace(/\D/g, '').slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}

/** Telefone: "(00) 0000-0000" (ate 10 digitos) ou "(00) 00000-0000" (11). So digitos entram; corta em 11. */
export function mascaraTelefone(valor: string): string {
  const d = valor.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  const ddd = `(${d.slice(0, 2)}`;
  if (d.length <= 2) return ddd;
  const resto = d.slice(2);
  const corte = resto.length > 8 ? 5 : 4;
  if (resto.length <= corte) return `${ddd}) ${resto}`;
  return `${ddd}) ${resto.slice(0, corte)}-${resto.slice(corte)}`;
}
